import { Link } from "react-router-dom";

// Breadcrumb trail for pages without the PageHeader banner (event details,
// coming soon). Same item format as PageHeader:
//   [{ label, href?, icon?, active?, lang? }] - the last item is the current page.
// `variant="light"` for white backgrounds, "dark" for text on dark images.
// Structured data (BreadcrumbList) comes from the page's Seo entry, not here.
const Breadcrumbs = ({ items, variant = "light", className = "" }) => (
  <nav aria-label="breadcrumb" className={`breadcrumbs-${variant} ${className}`}>
    <ol className="breadcrumb m-0 flex-nowrap">
      {items.map((item, index) => {
        const current = item.active || index === items.length - 1;
        return (
          <li
            key={`${item.label}-${index}`}
            className={`breadcrumb-item ${current ? "active text-truncate" : "flex-shrink-0"}`}
            aria-current={current ? "page" : undefined}
            lang={item.lang}
          >
            {current ? (
              item.label
            ) : (
              <Link to={item.href} className="text-decoration-none">
                {item.icon && <i className={`bi ${item.icon} me-1`} aria-hidden="true"></i>}
                {item.label}
              </Link>
            )}
          </li>
        );
      })}
    </ol>
  </nav>
);

export default Breadcrumbs;
